"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M23 3.79c.49 0 .9.36.99.87H24v3.93c0 .49-.35.9-.86 1h-3.93c-.55 0-1-.45-1-1 0-.49.35-.9.86-1h1.71c-.15-.24-.3-.46-.46-.69-.86-1.27-1.83-2.32-2.9-3.11C15.8 2.6 13.98 2 12 2 6.49 2 2 6.49 2 12c0 .55-.45 1-1 1s-1-.45-1-1C0 5.38 5.38 0 12 0c3.99 0 7.44 2.01 10 5.8V4.79c0-.55.45-1 1-1ZM22 12c0-.55.45-1 1-1s1 .45 1 1c0 6.62-5.38 12-12 12-3.98 0-7.44-2.01-10-5.8v1.01c0 .55-.45 1-1 1-.49 0-.9-.35-1-.86v-3.93c0-.49.35-.9.86-1h3.93c.55 0 1 .45 1 1 0 .49-.35.9-.86 1H3.22c.109.178.223.345.339.513l.101.147c.87 1.28 1.85 2.34 2.92 3.13C8.2 21.4 10.02 22 12 22c5.51 0 10-4.49 10-10Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M15 13.697c0-1.388-1.1-2.057-2.358-2.41l-.904-.262c-.786-.21-.851-.616-.851-.812 0-.511.419-.904 1.034-.904.642 0 1.035.419 1.022 1.035h1.795c.026-1.376-.904-2.346-2.332-2.516V6.61h-.93v1.22c-1.376.183-2.411 1.113-2.411 2.41 0 .747.328 1.834 2.149 2.332l.995.288c.734.223.97.576.97.93 0 .524-.407.917-1.127.917-.799 0-1.244-.445-1.244-1.087H9c0 1.322.969 2.357 2.476 2.553v1.219h.93v-1.219c1.402-.131 2.594-.996 2.594-2.476Z"
  })]
});